import { render, staticRenderFns } from "./BastionModal.vue?vue&type=template&id=6776fad0&"
import script from "./BastionModal.vue?vue&type=script&lang=js&"
export * from "./BastionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports